import { render, staticRenderFns } from "./Detalhe.vue?vue&type=template&id=48741ac0"
import script from "./Detalhe.vue?vue&type=script&lang=js"
export * from "./Detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports